import React from 'react'
import Tooltip from '../Tooltip'
import Button from '../Button'
import { Link } from 'gatsby'

import * as styles from './navDropdown.module.scss'

export default function NavDropdown({
  nav,
  text,
  theme = 'none',
  offset = 10,
  offsetCross = 0,
}) {
  const chevronFill =
    theme === 'noneD' || theme === 'lightB' || theme === 'light'
      ? '#605DFF'
      : '#fff'

  return (
    <Tooltip
      offset={offset}
      offsetCross={offsetCross}
      trigger={
        <div key={text}>
          <Button aria-haspopup="menu" theme={theme} className={styles.trigger}>
            {text}
            <svg
              width="16"
              height="9"
              viewBox="0 0 16 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.9307 8.4209C7.70643 8.64746 7.33747 8.64746 7.1132 8.4209L0.168154 1.40478C-0.0561126 1.17822 -0.0561126 0.805485 0.168154 0.578923C0.392422 0.35236 0.761377 0.35236 0.985644 0.578923L7.52195 7.18211L14.0583 0.578924C14.2825 0.352362 14.6515 0.352362 14.8757 0.578924C15.1 0.805486 15.1 1.17822 14.8757 1.40478L7.9307 8.4209Z"
                fill={chevronFill}
              />
            </svg>
          </Button>
        </div>
      }
    >
      <ul className={styles.navDropdown}>
        {nav.map(({ text, to, href }, idx) => (
          <li key={idx}>
            {href ? (
              <a href={href} target="_blank" rel="noreferrer">
                {text}
              </a>
            ) : (
              <Link to={to} activeClassName={styles.active}>
                {text}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </Tooltip>
  )
}
